// Dependencies
import React from 'react';
import radium from 'radium';
import { PaymentTypesEnum, PaymentTypesIconsEnum } from "../../../components/payment-type/payment-types-enum";
import { ThemeContext } from "../../../components/theme/Theme.jsx";

function SelectedPaymentType(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		label: {
			fontWeight: 'normal'
		},
		container: {
			display: 'flex',
			alignItems: 'center',
		},
		img: {
			height: '2em',
			marginRight: '1em',
		},
	}
	return (
		<div style={style.container}>
			{PaymentTypesIconsEnum[props.selectedPaymentType] &&
				<img aria-hidden={true} style={style.img} src={PaymentTypesIconsEnum[props.selectedPaymentType]}
					alt={`Logo für Zahlungsart ${PaymentTypesEnum[props.selectedPaymentType]}`}></img>
			}
			{props.selectedPaymentType
				? <span style={style.label}>{PaymentTypesEnum[props.selectedPaymentType]}</span>
				: <span style={style.label}
						dangerouslySetInnerHTML={{
							__html: context.themeManager
								.getThemeTextOrHardcodedDefault('noPaymentNeeded'),
						}}></span>
			}
		</div>
	);
}

export default radium(SelectedPaymentType);
